"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.format = exports.disallowedText = void 0;
var _isomorphicDompurify = _interopRequireDefault(require("isomorphic-dompurify"));
var _marked = require("marked");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const disallowedText = exports.disallowedText = '[Markdown links may only link to Start, Staff App, Resource Library, Notion, or email addresses]';
_marked.marked.use({
  renderer: {
    link(href, title, text) {
      if (urlAllowed(href)) return `<a href="${href}"${title ? ` title="${title}"` : ''}>${text}</a>`;
      return disallowedText;
    },
    image() {
      return '[Markdown images are not supported]';
    }
  }
});
function urlAllowed(url) {
  if (url.startsWith('mailto:')) {
    return true;
  }
  if (url.match(/^https?:\/\/(www\.)?notion\.so\/boulder\//)) {
    return true;
  }
  if (url.match(/^https?:\/\/((staff|start|resources|www)\.)?boulder\.care($|\/)/)) {
    return true;
  }
  if (url.match(/^https?:\/\/(www\.)?goodrx.com($|\/)/)) {
    return true;
  }
  if (url.match(/^https?:\/\/(www\.)?findhelp.org($|\/)/)) {
    return true;
  }
  if (url.match(/^https?:\/\/(www\.)?samhsa.gov($|\/)/)) {
    return true;
  }
  if (url.match(/^https?:\/\/(www\.)?thesoarinitiative.org($|\/)/)) {
    return true;
  }
  if (url.match(/^https?:\/\/(www\.)?nextdistro.org($|\/)/)) {
    return true;
  }
  if (url.match(/^https?:\/\/(www\.)?cdc.gov($|\/)/)) {
    return true;
  }
  if (url.match(/^https?:\/\/(www\.)?primarycaresportsmedicine.com($|\/)/)) {
    return true;
  }
  if (url.match(/^https?:\/\/(www\.)?plannedparenthood.org($|\/)/)) {
    return true;
  }
  if (url.match(/^https?:\/\/(www\.)?genoahealthcare.com($|\/)/)) {
    return true;
  }
  return false;
}
const format = markdown => _isomorphicDompurify.default.sanitize(_marked.marked.parse(markdown, {
  breaks: true
}));
exports.format = format;